import type { Foto, Protokoll } from './domain/types';

export function fotosZu(protokoll: Protokoll, fotoIds: string[]): Foto[] {
	const ids = new Set(fotoIds);
	return protokoll.fotos.filter((foto) => ids.has(foto.id));
}

/**
 * Entfernt ein Foto samt aller Verweise. Die Funktion lebt zentral, damit
 * Raum-, Mangel- und Zähleransicht keine verwaisten Foto-IDs erzeugen.
 */
export function entferneFoto(protokoll: Protokoll, fotoId: string): Protokoll {
	return {
		...protokoll,
		fotos: protokoll.fotos.filter((foto) => foto.id !== fotoId),
		raeume: protokoll.raeume.map((raum) => ({
			...raum,
			fotoIds: raum.fotoIds.filter((id) => id !== fotoId),
			maengel: raum.maengel.map((mangel) => ({
				...mangel,
				fotoIds: mangel.fotoIds.filter((id) => id !== fotoId)
			}))
		})),
		zaehler: protokoll.zaehler.map((zaehler) => ({
			...zaehler,
			fotoIds: zaehler.fotoIds.filter((id) => id !== fotoId)
		}))
	};
}
